const Progress = {
  defaultProps: {
    size: 'sm',
    radius: 'none',
    color: 'primary',
  },
};

export default Progress;
